import { useContext, useState, useEffect } from 'react';
import { CompareSettings } from './CompareSettings';
import Container from '@/components/layout/Container';

export default function CompareRTE({ block, entryUid, onDesktop, position }) {
  const compareSettings = useContext(CompareSettings);
  const { compare_rte } = block;

  const [visibleProducts, setVisibleProducts] = useState([]);

  useEffect(() => {
    const tempArr = [];
    if (onDesktop) {
      compareSettings.desktopSelectors.forEach((selected) => {
        const matchingProduct = compare_rte.products[selected.index];
        tempArr.push(matchingProduct);
      });
    } else {
      compareSettings.mobileSelectors.forEach((selected) => {
        const matchingProduct = compare_rte.products[selected.index];
        tempArr.push(matchingProduct);
      });
    }

    setVisibleProducts(tempArr);
  }, [compareSettings, onDesktop, compare_rte]);

  return (
    <section
      id={entryUid + '_' + position}
      data-name="compare-products-cards"
      className="pt-[24px] pb-[24px] lg:pt-[34px] lg:pb-[34px]"
    >
      <Container fullPage={false}>
        <div
          className={`${onDesktop ? 'preheading-r' : 'preheading-s'} pb-2 pl-3`}
        >
          {compare_rte.row_title}
        </div>
        <div className="grid min-h-[200px] grid-cols-2 gap-x-[16px] sm:gap-x-[24px] lg:grid-cols-3 lg:gap-x-[32px]">
          {visibleProducts.map((product, index) => {
            return (
              <div
                key={index}
                className={`border-dawn-grey-80 w-full border-t-2 ${onDesktop ? 'body-r' : 'body-s'}`}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: product.description }}
                  className="mt-5 lg:mt-10"
                ></div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
